<template>
  <div>
    <!-- 政策咨询 -->
    <div class="wrapCon" v-show="topNav">
      <el-tooltip
        class="item"
        effect="dark"
        content="点击即可跳转至国家税务总局12366纳税服务平台，为您提供7×24小时智能咨询服务。"
        placement="bottom-start"
      >
        <div class="onlineConsult flexStyle" @click="toOnLine">
          <i class="el-icon-chat-line-round"></i>在线咨询
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="如您想咨询税费政策，可以拨打12366纳税服务热线或各县区办税服务厅咨询电话。"
        placement="bottom"
      >
        <div class="phoneConsult flexStyle" @click="alertInfo">
          <i class="el-icon-phone"></i>电话咨询
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="如您遇到办税操作问题，可以连通各办税服务厅业务窗口，为您提供远程视频操作辅导。"
        placement="bottom"
      >
        <div class="handleConsult flexStyle" @click="handleInfo">
          <i class="el-icon-s-claim"></i>在线办理
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="如您遇到政策疑难问题，可以预约税务专家团队，为您提供远程视频辅导。"
        placement="bottom"
      >
        <div class="orderConsult flexStyle" style="width: 170px;" @click="toAdvisory">
          <i class="el-icon-user-solid"></i>预约专家团队咨询
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="如您认为您依法纳税缴费的权利受到侵害，可以直接点击跳转到举报投诉页面，为您提供线上维权。"
        placement="bottom-end"
      >
        <div class="complaintConsult flexStyle" @click="complaintInfo">
          <i class="el-icon-phone-outline"></i>在线投诉
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="点击即可对我们的服务进行评价，我们将努力提高和改进为您提供更满意服务。"
        placement="bottom-start"
      >
        <div class="onlineJudge flexStyle" @click="toOnLineJudge">
          <i class="el-icon-chat-line-round"></i>在线评价
        </div>
      </el-tooltip>
    </div>
    <!-- <router-view></router-view> -->
    <phoneConsult v-if="showFlag=='phoneConsult'"></phoneConsult>
    <orderConsult v-if="showFlag=='orderConsult'"></orderConsult>
    <handleConsult v-if="showFlag=='handleConsult'"></handleConsult>
  </div>
</template>

<script>
import $tjCommonDialog from "@/components/tj-common-dialog/index.js";
import handleConsult from "./componeent/handleConsult"
import phoneConsult from "./componeent/phoneConsult"
import orderConsult from "./componeent/orderConsult"
export default {
  name: "PolicyConsult",
  components: {
    handleConsult,
    phoneConsult,
    orderConsult,
  },
  props: {},
  data() {
    return {
      topNav:true,
      showFlag:"",
    };
  },
  created() {
    if(sessionStorage.getItem("showFlag")){
      this.topNav = false;
      this.showFlag = sessionStorage.getItem("showFlag")
    }
  },
  mounted() {},
  methods: {
    toOnLine() {
      let href = "https://12366.chinatax.gov.cn/xiaohui/";
      window.open(href, "_blank");
    },
    toAdvisory() {
      // $tjCommonDialog.init({
      //   width: "400px",
      //   showClose: true,
      //   contentComponent: () => import("../sf-policy-library/ExpertAdvisory"),
      // });
      this.topNav = false;
      this.showFlag = "orderConsult"
    },
    handleInfo() {
      // $tjCommonDialog.init({
      //   width: "400px",
      //   showClose: true,
      //   contentComponent: () => import("../sf-policy-library/ExpertAdvisoryBl"),
      // });
      this.topNav = false;
      this.showFlag = "handleConsult"
    },
    complaintInfo() {
      let href =
        "https://henan.chinatax.gov.cn/xinyang/hdjl/sswfxwjj/wyxx/index.html";
      window.open(href, "_blank");
    },
    alertInfo() {
      // $tjCommonDialog.init({
      //   width: "400px",
      //   showClose: true,
      //   contentComponent: () => import("../sf-policy-library/ExpertAdvisoryZx"),
      // });

      // const h = this.$createElement;
      // this.$message({
      //   message: h("p", null, [
      //     h("span", null, "请拨打 "),
      //     h("i", { style: "color: red" }, "12366"),
      //     h("span", null, "  进行咨询 "),
      //   ]),
      // });
      this.topNav = false;
      this.showFlag = "phoneConsult"
    },
     toOnLineJudge() {
      let href = "https://www.wjx.cn/vj/tG73KG4.aspx";
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.flexStyle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.wrapCon {
  width: $width;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  .onlineConsult,
  .orderConsult,
  .handleConsult,
  .complaintConsult,
  .phoneConsult,
  .onlineJudge {
    height: 160px;
    width: 160px;
    border-radius: 10px;
    color: #fff;
    font-size: 18px;
    margin: 20px 30px 20px 20px;
    cursor: pointer;
    i {
      font-size: 45px;
      display: block;
    }
    &:hover {
      box-shadow: 0 0 5px #ef0000;
    }
  }
  .onlineConsult {
    background: #ef0000;
  }
  .orderConsult {
    background-color: #ff9b2b;
  }
  .phoneConsult {
    background-color: #00aff6;
    &:hover {
      box-shadow: 0 0 5px #00aff6;
    }
  }
  .handleConsult {
    background-color: #07c160;
    &:hover {
      box-shadow: 0 0 5px #07c160;
    }
  }
  .complaintConsult {
    background-color: #b4c160;
    &:hover {
      box-shadow: 0 0 5px #b4c160;
    }
  }
  .onlineJudge {
    background-color: #d04ed6;
     &:hover {
      box-shadow: 0 0 5px #d04ed6;
    }
  }
}
</style>
